import { ClientModel, UserModel } from 'shared';

export interface GpAsteriskConfigModel {
  wsPort: number;
  appName: string;
  // повна адреса WS-сервера (wss://host); потрібна нативному mobile, де window.location — це localhost застосунку
  wsBaseUrl?: string | null;
}

export const GP_ASTERISK_CONFIG_TOKEN = 'GP_ASTERISK_CONFIG_TOKEN';


export interface CallLogModel {
  id: string;
  createdAt: string;
  channelId: string;
  recordPath: string;
  talkTime: number;
  codeDevice: string;
  userName: string;
  phone: string;
  isAnswer: boolean;
  type: TypeCall;
  user?: UserModel;
  deviceUser: UserModel;
  client?: ClientModel;
  contact?: ContactModel;
  telegram?: TelegramModel;
}

export interface GpCallModel {
  id: string;
  createdAt: string;
  phone: string;
  type: TypeCall;
  status: CallingState;
  isDisabled: boolean;
  isHold: boolean;
  answered?: string;
  nameCaller?: string;
  SIP_number?: string;
  dialedId?: string;
  idCustomerCard: string;
  isDial?: boolean;
  transferredFrom?: string;
  conferenceMembers?: string[];
  // консультативне переведення, що триває
  transfer?: CallTransferModel;
}

export interface CallTransferModel {
  from: string;
  to: string;
  toName?: string;
  // ringing — номеру дзвонимо, talking — оператор говорить з ним, клієнт на утриманні
  status: 'ringing' | 'talking';
  // запрошення колеги (а не переадресація): після підтвердження він приєднається в цьому режимі
  mode?: MonitorMode;
}

// текст кнопки підтвердження консультації (переадресація / запрошення в режимі)
export const CONSULT_CONFIRM_LABELS: Record<'transfer' | MonitorMode, string> = {
  transfer: 'Підтвердити переведення',
  conference: 'Почати конференцію',
  whisper: 'Підключити суфлера',
  listen: 'Підключити слухача'
};

export interface GpCallMetaModel extends GpCallModel {
  street?: string;
  country?: string;
  city?: string;
  numberOfDoc?: string;
  typeOfDoc?: DocNameEnum;
  docCreatedAt?: string;
  statusOfDoc?: {
    status: string;
  };
  client?: ClientModel;
  telegramBot: TelegramModel;
  user?: UserModel;
}

export const docStatus = {
  ISSUED: 'Видано',
  ACCEPTED: 'Прийнято',
  ISSUED_SELF: 'Видано самостійно',
  CANCELLED: 'Відмінено',
  DONE: 'Виконано',
  NOT_CONFIRMED: 'Очікує підтвердження',
  READY_TO_PICKUP: 'Готово до видачі',
  INFORMED: 'Проінформовано'
};


export enum DocNameEnum {
  TALON = 'TALON',
  ORDER = 'ORDER',
  STAND = 'STAND',
  CONTRACT = 'CONTRACT',
}

export const DocTypeRelationName = {
  [DocNameEnum.TALON]: 'Гарантійний талон',
  [DocNameEnum.ORDER]: 'Виклик',
  [DocNameEnum.STAND]: 'Ремонт на стенді',
  [DocNameEnum.CONTRACT]: 'Договір'
};

export enum TypeCall {
  InCall = 'inCall',
  OutCall = 'outCall',
  NotWorkTime = 'notWorkTime',
  // дзвінок між співробітниками: phone — внутрішній номер того, хто дзвонив, codeDevice — кому
  Internal = 'internal'
}

export enum CallingState {
  WaitingForAnAnswer = 'waitingOfAnswer',
  Ringing = 'ringing',
  Ring = 'ring',
  Answered = 'answered'
}

export enum CONNECT_STATUS_WS {
  CONNECTED = 'connected',
  CONNECTING = 'connecting',
  DISCONNECT = 'disconnect',
  DISCONNECT_BACKEND = 'disconnectBackend',
  SIP_CLIENT_NOT_CONNECTED = 'SIP_CLIENT_NOT_CONNECTED',
}

export interface AsteriskEndpoint {
  channel_ids: [];
  resource: string;
  state: string | 'online';
  technology: string | 'SIP';
}

export interface ToCallModel {
  context: string;
  callerId: string;
  extension: string;
  app: string;
  variables: {
    'CALLERID(name)': string;
  },
  appArgs: string;
}

export interface ToCallResponseModel {
  id: string;
  name: string;
  state: string;
  caller: { name: string; number: string; };
  connected: { name: string; number: string; };
  accountcode: string;
  dialplan: { context: string; exten: string; priority: number; };
  creationtime: string;
  language: string;
}

export interface ExtensionStatusModel {
  status: number;
  statusText: ExtensionStatusEnum;
  exten: string;
}

export enum ExtensionStatusEnum {
  IDLE = 'Idle',
  UNAVAILABLE = 'Unavailable',
  OFFLINE = 'offline',
  ONLINE = 'online',
  RINGING = 'Ringing',
  IN_USE = 'InUse',
  UNKNOWN = 'unknown',
  REACHABLE = 'Reachable',
  UNREACHABLE = 'Unreachable',
  REGISTERED = 'Registered',
  UNREGISTER = 'Unregister',
}


export interface ContactModel {
  id: string;
  phone: string;
  phone2?: string;
  sipPhone?: string;
  comment?: string;
  firstName: string;
  lastName: string;
  avatarPath?: string;
  isFavorite: boolean;
  user?: UserModel;
  client?: ClientModel;
  telegram?: TelegramModel;
}

export enum DongleStatusEnum {
  UNREGISTER = 'Unregister',
  REACHABLE = 'Reachable',
  UNREACHABLE = 'Unreachable',
  REGISTER = 'Register',
  REGISTERED = 'Registered',
  FREE = 'Free',
  CONNECT = 'Connect',
  DISCONNECT = 'Disconnect',
  USED = 'Used',
  INITIALIZE = 'Initialize'
}

export interface TelegramModel {
  id: string;
  avatarPath: string;
  chatId: number;
  tel: string;
}

export interface RoutineModel {
  isEnabled?: boolean;
  start: { hour: string; minute: string };
  finish: { hour: string; minute: string };
}

export interface AsteriskRoutineData {
  id: string;
  monday: RoutineModel;
  tuesday: RoutineModel;
  wednesday: RoutineModel;
  thursday: RoutineModel;
  friday: RoutineModel;
  saturday: RoutineModel;
  sunday: RoutineModel;
}

export interface DirectCallModel {
  id: string;
  sipNumber: string;
  isEnabled: boolean;
  createdAt: string;
}

export type SpyMode = 'listen' | 'whisper';

// режим, у якому користувач підключений до чужої розмови
export type MonitorMode = SpyMode | 'conference';

export interface MonitorResultModel {
  mode: MonitorMode;
  // true — телефон уже був на лінії, режим просто змінено
  switched: boolean;
}

export interface TransferTargetModel {
  username: string;
  name: string;
  isRegistered: boolean;
  // зараз у розмові (з клієнтом або внутрішній дзвінок)
  inCall?: boolean;
  // вбудований телефон у застосунку — дзвінок дійде push-ом, навіть якщо застосунок закритий
  hasApp?: boolean;
  // останній сигнал від застосунку (ISO) — «був у мережі … тому»
  lastSeenAt?: string;
}

// Внутрішній дзвінок між співробітниками (id починається з INTERNAL_CALL_PREFIX)
export const INTERNAL_CALL_PREFIX = 'internal-';

export interface InternalCallModel {
  id: string;
  fromSip: string;
  fromName: string;
  toSip: string;
  toName: string;
  status: 'ringing' | 'active' | 'ended';
  reason?: 'no-answer' | 'unavailable' | 'hangup';
  // дзвінок у застосунок: чекаємо підтвердження / телефон отримав / не відгукнувся (поза мережею)
  delivery?: 'pending' | 'delivered' | 'unreachable';
  // callback — дзвінок клієнту з веб-CRM: спершу дзвонить вам (fromSip/fromName — номер і ім'я клієнта)
  kind?: 'callback';
}

export interface SipAccountModel {
  id: string;
  username: string;
  callerid?: string;
  createdAt: string;
  isRegistered: boolean;
}

// Публічна адреса АТС: SIP — для сторонніх застосунків, WSS — для вбудованого телефону (WebRTC)
export interface AsteriskServerSettingsModel {
  host: string;
  sipPort: number;
  wssPort: number;
  wsPath: string;
}

export interface SoftphoneConfigModel {
  enabled: boolean;
  reason?: string;
  username?: string;
  password?: string;
  displayName?: string;
  domain?: string;
  wssUrl?: string;
}

